import { render, staticRenderFns } from "./PasswordForm.vue?vue&type=template&id=6c8355a4&scoped=true"
import script from "./PasswordForm.vue?vue&type=script&lang=js"
export * from "./PasswordForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8355a4",
  null
  
)

export default component.exports